import { render } from "./pettycashin.vue?vue&type=template&id=1501af03"
import script from "./pettycashin.vue?vue&type=script&lang=js"
export * from "./pettycashin.vue?vue&type=script&lang=js"

import "./pettycashin.vue?vue&type=style&index=0&id=1501af03&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__